var _rect, _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _g2, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwoStep2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 107,
    viewBox: "0 0 117 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 117,
    height: 107,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.4354 30.1875V17.588C52.5473 15.7529 51.5626 13.336 51.5626 11.6128C51.5626 9.88958 49.5485 10.0015 49.5485 10.0015H43.6851H42.7676H36.9043C36.9043 10.0015 34.8901 9.88958 34.8901 11.6128C34.8901 13.336 33.9054 15.7529 34.0173 17.588V30.1651C34.0173 30.1651 33.6816 32.694 35.9643 32.694H42.7452C43.3047 32.694 43.6628 32.694 43.6628 32.694H50.4437C52.7487 32.694 52.3907 30.1651 52.3907 30.1651L52.4354 30.1875Z",
    fill: "#9E8959"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_463_10690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 32,
    width: 18,
    height: 65
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7212 32.6484H34.7578V96.6305H51.7212V32.6484Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_463_10690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.6124 26.293H42.8515C39.156 26.293 36.1602 29.2889 36.1602 32.9844V88.3505C36.1602 92.0461 39.156 95.0419 42.8515 95.0419H43.6124C47.308 95.0419 50.3038 92.0461 50.3038 88.3505V32.9844C50.3038 29.2889 47.308 26.293 43.6124 26.293Z",
    fill: "white",
    stroke: "#05054B",
    strokeWidth: 1.55556,
    strokeMiterlimit: 10
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2383 13.5156V29.0244",
    stroke: "white",
    strokeWidth: 1.67,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4023 15.418V29.0245",
    stroke: "white",
    strokeWidth: 1.67,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0469 15.418V29.0245",
    stroke: "white",
    strokeWidth: 1.67,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6061 41.627H39.293V84.2546H49.6061",
    stroke: "#9E8959",
    strokeWidth: 1.37509
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0195 54.9746V55.3702H49.8023V54.9746H45.0195Z",
    fill: "#33333F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0195 54.5293V54.727H49.8023V54.5293H45.0195Z",
    fill: "#33333F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0195 53.8867V54.0845H49.8023V53.8867H45.0195Z",
    fill: "#33333F"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0195 52.8242V53.022H49.8023V52.8242H45.0195Z",
    fill: "#33333F"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0195 51.9824V52.1802H49.8023V51.9824H45.0195Z",
    fill: "#33333F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9883 50.9199V51.3155H49.771V50.9199H44.9883Z",
    fill: "#33333F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0195 50.4492V50.647H49.8023V50.4493L45.0195 50.4492Z",
    fill: "#33333F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9883 49.2148V49.8329H49.771V49.2148H44.9883Z",
    fill: "#33333F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0195 48.127V48.3248H49.8023V48.127H45.0195Z",
    fill: "#33333F"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0195 48.5703V48.9659H49.8023V48.5703H45.0195Z",
    fill: "#33333F"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0195 47.2852V47.9033H49.8023V47.2852H45.0195Z",
    fill: "#33333F"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0195 46.2227V46.6183H49.8023V46.2227H45.0195Z",
    fill: "#33333F"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0195 45.752V45.9498H49.8023V45.752H45.0195Z",
    fill: "#33333F"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0195 64.6016V64.9972H49.8023V64.6016H45.0195Z",
    fill: "#33333F"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0195 64.1562V64.354H49.8023V64.1562H45.0195Z",
    fill: "#33333F"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0195 63.5137V63.7115H49.8023V63.5138L45.0195 63.5137Z",
    fill: "#33333F"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0195 62.4492V62.647H49.8023V62.4492H45.0195Z",
    fill: "#33333F"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0195 61.6094V61.8072H49.8023V61.6094H45.0195Z",
    fill: "#33333F"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9883 60.5449V60.9405H49.771V60.5449H44.9883Z",
    fill: "#33333F"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0195 60.0762V60.274H49.8023V60.0762H45.0195Z",
    fill: "#33333F"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9883 58.8418V59.4599H49.771V58.8418H44.9883Z",
    fill: "#33333F"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0195 57.7539V57.9517H49.8023V57.7539H45.0195Z",
    fill: "#33333F"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0195 58.1973V58.5929H49.8023V58.1973H45.0195Z",
    fill: "#33333F"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0195 56.9121V57.5302H49.8023V56.9121H45.0195Z",
    fill: "#33333F"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0195 55.8496V56.2452H49.8023V55.8496H45.0195Z",
    fill: "#33333F"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0195 55.3789V55.5767H49.8023V55.3789H45.0195Z",
    fill: "#33333F"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0195 74.2266V74.6222H49.8023V74.2266H45.0195Z",
    fill: "#33333F"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0195 73.7812V73.979H49.8023V73.7812H45.0195Z",
    fill: "#33333F"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0195 73.1387V73.3365H49.8023V73.1387H45.0195Z",
    fill: "#33333F"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0195 72.0742V72.272H49.8023V72.0743L45.0195 72.0742Z",
    fill: "#33333F"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0195 71.2344V71.4322H49.8023V71.2344H45.0195Z",
    fill: "#33333F"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9883 70.1719V70.5675H49.771V70.1719H44.9883Z",
    fill: "#33333F"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0195 69.7012V69.899H49.8023V69.7012H45.0195Z",
    fill: "#33333F"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9883 68.4668V69.0849H49.771V68.4668H44.9883Z",
    fill: "#33333F"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0195 67.377V67.5748H49.8023V67.377H45.0195Z",
    fill: "#33333F"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0195 67.8223V68.2179H49.8023V67.8223H45.0195Z",
    fill: "#33333F"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0195 66.5371V67.1552H49.8023V66.5371H45.0195Z",
    fill: "#33333F"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0195 65.4746V65.8702H49.8023V65.4746H45.0195Z",
    fill: "#33333F"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0195 65.0039V65.2016H49.8023V65.0039H45.0195Z",
    fill: "#33333F"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9883 77.6211V78.0167H49.771V77.6211H44.9883Z",
    fill: "#33333F"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9883 77.1758V77.3736H49.771V77.1758H44.9883Z",
    fill: "#33333F"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9883 76.5332V76.731H49.771V76.5332H44.9883Z",
    fill: "#33333F"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9883 75.4707V75.6684H49.771V75.4707H44.9883Z",
    fill: "#33333F"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9883 74.6289V74.8267H49.771V74.6289H44.9883Z",
    fill: "#33333F"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2156 57.4896C42.2156 57.4896 42.2438 57.4333 42.2719 57.4333H42.7367C42.7367 57.4333 42.793 57.4614 42.793 57.4896V59.1937C42.793 59.1937 42.7649 59.2641 42.7226 59.2641C41.3847 59.2501 40.5537 58.6445 40.5537 57.3769C40.5537 56.1657 41.3847 55.377 42.6381 55.377C43.8916 55.377 44.7225 56.208 44.7225 57.4614C44.7225 58.0952 44.5112 58.5599 44.1732 58.912C44.145 58.9402 44.1169 58.9261 44.1028 58.912L43.6521 58.5459C43.6521 58.5459 43.6381 58.5177 43.6381 58.5036C43.6381 58.4895 43.6381 58.4754 43.6521 58.4614C43.8071 58.2924 44.0324 57.9121 44.0324 57.4473C44.0324 56.6164 43.4831 56.0671 42.6522 56.0671C41.8213 56.0671 41.272 56.5882 41.272 57.3769C41.272 58.0248 41.5959 58.4332 42.2297 58.5459V57.4755L42.2156 57.4896Z",
    fill: "#9E8959"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7225 61.7856C44.7225 63.039 43.8916 63.8559 42.6381 63.8559C41.3847 63.8559 40.5537 63.039 40.5537 61.7856C40.5537 60.5321 41.3847 59.7012 42.6381 59.7012C43.8916 59.7012 44.7225 60.5321 44.7225 61.7856ZM41.2579 61.7856C41.2579 62.6024 41.8072 63.1658 42.6381 63.1658C43.469 63.1658 44.0183 62.6165 44.0183 61.7856C44.0183 60.9546 43.4691 60.4053 42.6381 60.4053C41.8072 60.4053 41.2579 60.9546 41.2579 61.7856Z",
    fill: "#9E8959"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2412 66.5316C41.2412 66.5316 41.2271 66.5879 41.1849 66.5879H40.6638C40.6638 66.5879 40.6074 66.5598 40.6074 66.5316V64.574C40.6074 64.574 40.6356 64.5176 40.6638 64.5176H44.6072C44.6072 64.5176 44.6636 64.5458 44.6636 64.574V65.1655C44.6636 65.1655 44.6354 65.2218 44.6072 65.2218H41.2412V66.5316Z",
    fill: "#9E8959"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6074 67.236C40.6074 67.236 40.6356 67.1797 40.6638 67.1797H44.6072C44.6072 67.1797 44.6636 67.2078 44.6636 67.236V68.4331C44.6636 69.6725 43.8749 70.5034 42.6355 70.5034C41.3961 70.5034 40.6074 69.6725 40.6074 68.4331V67.236ZM44.0157 67.8839H41.2834V68.4331C41.2834 69.2641 41.8186 69.8133 42.6496 69.8133C43.4805 69.8133 44.0157 69.2641 44.0157 68.4331V67.8839Z",
    fill: "#9E8959"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4354 30.1875V17.588C82.5473 15.7529 81.5626 13.336 81.5626 11.6128C81.5626 9.88958 79.5485 10.0015 79.5485 10.0015H73.6851H72.7676H66.9043C66.9043 10.0015 64.8901 9.88958 64.8901 11.6128C64.8901 13.336 63.9054 15.7529 64.0173 17.588V30.1651C64.0173 30.1651 63.6816 32.694 65.9643 32.694H72.7452C73.3047 32.694 73.6628 32.694 73.6628 32.694H80.4437C82.7487 32.694 82.3907 30.1651 82.3907 30.1651L82.4354 30.1875Z",
    fill: "#995BA5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_463_10690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 64,
    y: 32,
    width: 18,
    height: 65
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7212 32.6484H64.7578V96.6305H81.7212V32.6484Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_463_10690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.6124 26.293H72.8515C69.156 26.293 66.1602 29.2889 66.1602 32.9844V88.3505C66.1602 92.0461 69.156 95.0419 72.8515 95.0419H73.6124C77.308 95.0419 80.3038 92.0461 80.3038 88.3505V32.9844C80.3038 29.2889 77.308 26.293 73.6124 26.293Z",
    fill: "white",
    stroke: "#05054B",
    strokeWidth: 1.55556,
    strokeMiterlimit: 10
  }))), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2383 13.5156V29.0244",
    stroke: "white",
    strokeWidth: 1.67,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4023 15.418V29.0245",
    stroke: "white",
    strokeWidth: 1.67,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0469 15.418V29.0245",
    stroke: "white",
    strokeWidth: 1.67,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6061 41.627H69.293V84.2546H79.6061",
    stroke: "#995BA5",
    strokeWidth: 1.37509
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0195 54.9746V55.3702H79.8023V54.9746H75.0195Z",
    fill: "#33333F"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0195 54.5293V54.727H79.8023V54.5293H75.0195Z",
    fill: "#33333F"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0195 53.8867V54.0845H79.8023V53.8867H75.0195Z",
    fill: "#33333F"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0195 52.8242V53.022H79.8023V52.8242H75.0195Z",
    fill: "#33333F"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0195 51.9824V52.1802H79.8023V51.9824H75.0195Z",
    fill: "#33333F"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9883 50.9199V51.3155H79.771V50.9199H74.9883Z",
    fill: "#33333F"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0195 50.4492V50.647H79.8023V50.4493L75.0195 50.4492Z",
    fill: "#33333F"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9883 49.2148V49.8329H79.771V49.2148H74.9883Z",
    fill: "#33333F"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0195 48.127V48.3248H79.8023V48.127H75.0195Z",
    fill: "#33333F"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0195 48.5703V48.9659H79.8023V48.5703H75.0195Z",
    fill: "#33333F"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0195 47.2852V47.9033H79.8023V47.2852H75.0195Z",
    fill: "#33333F"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0195 46.2227V46.6183H79.8023V46.2227H75.0195Z",
    fill: "#33333F"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0195 45.752V45.9498H79.8023V45.752H75.0195Z",
    fill: "#33333F"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0195 64.6016V64.9972H79.8023V64.6016H75.0195Z",
    fill: "#33333F"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0195 64.1562V64.354H79.8023V64.1562H75.0195Z",
    fill: "#33333F"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0195 63.5137V63.7115H79.8023V63.5138L75.0195 63.5137Z",
    fill: "#33333F"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0195 62.4492V62.647H79.8023V62.4492H75.0195Z",
    fill: "#33333F"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0195 61.6094V61.8072H79.8023V61.6094H75.0195Z",
    fill: "#33333F"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9883 60.5449V60.9405H79.771V60.5449H74.9883Z",
    fill: "#33333F"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0195 60.0762V60.274H79.8023V60.0762H75.0195Z",
    fill: "#33333F"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9883 58.8418V59.4599H79.771V58.8418H74.9883Z",
    fill: "#33333F"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0195 57.7539V57.9517H79.8023V57.7539H75.0195Z",
    fill: "#33333F"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0195 58.1973V58.5929H79.8023V58.1973H75.0195Z",
    fill: "#33333F"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0195 56.9121V57.5302H79.8023V56.9121H75.0195Z",
    fill: "#33333F"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0195 55.8496V56.2452H79.8023V55.8496H75.0195Z",
    fill: "#33333F"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0195 55.3789V55.5767H79.8023V55.3789H75.0195Z",
    fill: "#33333F"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0195 74.2266V74.6222H79.8023V74.2266H75.0195Z",
    fill: "#33333F"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0195 73.7812V73.979H79.8023V73.7812H75.0195Z",
    fill: "#33333F"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0195 73.1387V73.3365H79.8023V73.1387H75.0195Z",
    fill: "#33333F"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0195 72.0742V72.272H79.8023V72.0743L75.0195 72.0742Z",
    fill: "#33333F"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0195 71.2344V71.4322H79.8023V71.2344H75.0195Z",
    fill: "#33333F"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9883 70.1719V70.5675H79.771V70.1719H74.9883Z",
    fill: "#33333F"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0195 69.7012V69.899H79.8023V69.7012H75.0195Z",
    fill: "#33333F"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9883 68.4668V69.0849H79.771V68.4668H74.9883Z",
    fill: "#33333F"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0195 67.377V67.5748H79.8023V67.377H75.0195Z",
    fill: "#33333F"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0195 67.8223V68.2179H79.8023V67.8223H75.0195Z",
    fill: "#33333F"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0195 66.5371V67.1552H79.8023V66.5371H75.0195Z",
    fill: "#33333F"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0195 65.4746V65.8702H79.8023V65.4746H75.0195Z",
    fill: "#33333F"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0195 65.0039V65.2016H79.8023V65.0039H75.0195Z",
    fill: "#33333F"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9883 77.6211V78.0167H79.771V77.6211H74.9883Z",
    fill: "#33333F"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9883 77.1758V77.3736H79.771V77.1758H74.9883Z",
    fill: "#33333F"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9883 76.5332V76.731H79.771V76.5332H74.9883Z",
    fill: "#33333F"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9883 75.4707V75.6684H79.771V75.4707H74.9883Z",
    fill: "#33333F"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9883 74.6289V74.8267H79.771V74.6289H74.9883Z",
    fill: "#33333F"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2156 57.4896C72.2156 57.4896 72.2438 57.4333 72.2719 57.4333H72.7367C72.7367 57.4333 72.793 57.4614 72.793 57.4896V59.1937C72.793 59.1937 72.7649 59.2641 72.7226 59.2641C71.3847 59.2501 70.5537 58.6445 70.5537 57.3769C70.5537 56.1657 71.3847 55.377 72.6381 55.377C73.8916 55.377 74.7225 56.208 74.7225 57.4614C74.7225 58.0952 74.5112 58.5599 74.1732 58.912C74.145 58.9402 74.1169 58.9261 74.1028 58.912L73.6521 58.5459C73.6521 58.5459 73.6381 58.5177 73.6381 58.5036C73.6381 58.4895 73.6381 58.4754 73.6521 58.4614C73.8071 58.2924 74.0324 57.9121 74.0324 57.4473C74.0324 56.6164 73.4831 56.0671 72.6522 56.0671C71.8213 56.0671 71.272 56.5882 71.272 57.3769C71.272 58.0248 71.5959 58.4332 72.2297 58.5459V57.4755L72.2156 57.4896Z",
    fill: "#995BA5"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7225 61.7856C74.7225 63.039 73.8916 63.8559 72.6381 63.8559C71.3847 63.8559 70.5537 63.039 70.5537 61.7856C70.5537 60.5321 71.3847 59.7012 72.6381 59.7012C73.8916 59.7012 74.7225 60.5321 74.7225 61.7856ZM71.2579 61.7856C71.2579 62.6024 71.8072 63.1658 72.6381 63.1658C73.469 63.1658 74.0183 62.6165 74.0183 61.7856C74.0183 60.9546 73.4691 60.4053 72.6381 60.4053C71.8072 60.4053 71.2579 60.9546 71.2579 61.7856Z",
    fill: "#995BA5"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2412 66.5316C71.2412 66.5316 71.2271 66.5879 71.1849 66.5879H70.6638C70.6638 66.5879 70.6074 66.5598 70.6074 66.5316V64.574C70.6074 64.574 70.6356 64.5176 70.6638 64.5176H74.6072C74.6072 64.5176 74.6636 64.5458 74.6636 64.574V65.1655C74.6636 65.1655 74.6354 65.2218 74.6072 65.2218H71.2412V66.5316Z",
    fill: "#995BA5"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6074 67.236C70.6074 67.236 70.6356 67.1797 70.6638 67.1797H74.6072C74.6072 67.1797 74.6636 67.2078 74.6636 67.236V68.4331C74.6636 69.6725 73.8749 70.5034 72.6355 70.5034C71.3961 70.5034 70.6074 69.6725 70.6074 68.4331V67.236ZM74.0157 67.8839H71.2834V68.4331C71.2834 69.2641 71.8186 69.8133 72.6496 69.8133C73.4805 69.8133 74.0157 69.2641 74.0157 68.4331V67.8839Z",
    fill: "#995BA5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoStep2);
export default __webpack_public_path__ + "static/media/twoStep_2.a946ca2448b7beb64a912d6817ce2db5.svg";
export { ForwardRef as ReactComponent };